import React from 'react';
import styled from 'styled-components';
import DeleteButton from './DeleteButton';
import ResetSizeButton from './ResetSizeButton';

interface CardHeaderProps {
  onDelete: (e: React.MouseEvent) => void;
  onResetSize?: (e: React.MouseEvent) => void;
}

// カードのヘッダー
const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  
  & > * {
    pointer-events: auto; // 子要素（削除ボタンなど）はポインターイベントを受け取る
  }
`;

// ドラッグハンドルの表示用テキスト
const DragHandleText = styled.div`
  font-size: 16px;
  color: #888;
  margin-right: auto;
  display: flex;
  align-items: center;
  
  &::before {
    content: '≡';
    font-size: 16px;
  }
`;

const CardHeader: React.FC<CardHeaderProps> = ({ onDelete, onResetSize }) => {
  return (
    <HeaderContainer>
      <DragHandleText></DragHandleText>
      {onResetSize && (
        <ResetSizeButton 
          onClick={onResetSize}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        />
      )}
      <DeleteButton 
        onClick={onDelete}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      />
    </HeaderContainer>
  );
};

export default CardHeader; 